var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 11.1666C9.47243 11.1666 10.6663 9.97274 10.6663 8.49998C10.6663 7.02722 9.47243 5.83331 7.99967 5.83331C6.52692 5.83331 5.33301 7.02722 5.33301 8.49998C5.33301 9.97274 6.52692 11.1666 7.99967 11.1666Z",
    stroke: "#FFA54C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6663 5.83333V9.16666C10.6663 9.69709 10.8771 10.2058 11.2521 10.5809C11.6272 10.9559 12.1359 11.1667 12.6663 11.1667C13.1968 11.1667 13.7055 10.9559 14.0806 10.5809C14.4556 10.2058 14.6663 9.69709 14.6663 9.16666V8.49999C14.6663 6.99535 14.1572 5.53498 13.2219 4.35635C12.2866 3.17772 10.98 2.35014 9.51477 2.00819C8.0495 1.66624 6.51164 1.83002 5.15125 2.4729C3.79086 3.11579 2.68795 4.19996 2.02185 5.54914C1.35576 6.89832 1.16566 8.43315 1.48246 9.90407C1.79926 11.375 2.60433 12.6955 3.76677 13.6508C4.9292 14.6062 6.38064 15.1402 7.88506 15.1661C9.38949 15.192 10.8584 14.7082 12.053 13.7933",
    stroke: "#FFA54C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail11);
export default __webpack_public_path__ + "static/media/email11.8d33f87d350be6ca81650495f0957c42.svg";
export { ForwardRef as ReactComponent };